/**
 * REST client for the public booking wizard.
 */
export function createApi(cfg) {
	function buildUrl(path, query) {
		const base = cfg.apiBase.replace(/\/?$/, '/');
		let url = base + String(path || '').replace(/^\//, '');
		if (query && typeof query === 'object') {
			const parts = [];
			Object.keys(query).forEach((key) => {
				const val = query[key];
				if (val !== undefined && val !== null && val !== '') {
					parts.push(
						encodeURIComponent(key) + '=' + encodeURIComponent(String(val))
					);
				}
			});
			if (parts.length) {
				url += (url.indexOf('?') >= 0 ? '&' : '?') + parts.join('&');
			}
		}
		return url;
	}

	async function request(method, path, data, query) {
		const options = {
			method,
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': cfg.nonce,
			},
			credentials: 'same-origin',
		};

		if (data && method !== 'GET') {
			options.body = JSON.stringify(data);
		}

		const res = await fetch(buildUrl(path, query), options);
		let body = null;
		try {
			body = await res.json();
		} catch (e) {
			body = null;
		}

		if (!res.ok) {
			const msg =
				(body && body.message) ||
				(body && body.data && body.data.message) ||
				'Something went wrong. Please try again.';
			throw new Error(msg);
		}

		return body && body.success !== undefined ? body.data : body;
	}

	return {
		get: (path, query) => request('GET', path, null, query),
		post: (path, data) => request('POST', path, data),
		put: (path, data) => request('PUT', path, data),
	};
}
